import { config } from "../env";
import {
  Delete,
  get,
  patch,
  post,
  postFileUpload,
} from "./helpers/http-handler";

export const clientCreateLocation = (payload: object) =>
  post(`${config.API_URL}/locations`, payload);

export const clientGetLocation = (queryRequest: string) =>
  get(`${config.API_URL}/locations?${queryRequest}`);

export const clientGetEntityData = (queryRequest: string) =>
  get(`${config.API_URL}/locations/filter/location?${queryRequest}`);

export const clientUpAttachedLocation = (id:string,queryRequest: string) =>
  get(`${config.API_URL}/vendors/${id}/unAttachedLocation?${queryRequest}`);

export const clientGetSpecificLocation = (id: string) =>
  get(`${config.API_URL}/locations/${id}`);

export const clientUpdateSpecificLocation = (id: string, payload: object) =>
  patch(`${config.API_URL}/locations/${id}`, payload);

export const clientUpdateBulkStatusLocation = (payload: object) =>
  patch(`${config.API_URL}/locations/bulk/active-inactive`, payload);

export const adminBulkLocationUpdateStatus = (payload: object) =>
  patch(`${config.API_URL}/locations/bulk/active-inactive`, payload);

// functions

export const clientCreateFunction = (payload: object) =>
  post(`${config.API_URL}/functions`, payload);

export const clientGetFunction = (queryRequest: string) =>
  get(`${config.API_URL}/functions?${queryRequest}`);

export const clientGetSpecificFunction = (id: string) =>
  get(`${config.API_URL}/functions/${id}`);

export const clientUpdateSpecificFunction = (id: string, payload: object) =>
  patch(`${config.API_URL}/functions/${id}`, payload);

export const clientUpdateBulkStatusFunction = (payload: object) =>
  patch(`${config.API_URL}/functions/bulk/active-inactive`, payload);

export const clientDeleteBulkFunction = (id: string) =>
  Delete(`${config.API_URL}/functions/${id}`);

// vendor

export const clientUpdateLocationVendor = (id: string, payload: object) =>
  patch(`${config.API_URL}/locations/${id}/update-location-vendor`, payload);

export const clientGetLocationAttachedVendors = (id: string) =>
  get(`${config.API_URL}/locations/${id}/attachedVendors`);

export const clientGetLocationAttachedVendorNew = (
  id: string,
  queryRequest: string
) => get(`${config.API_URL}/locations/${id}/vendors?${queryRequest}`);

// upload

export const uploadLocations = (payload: object) =>
  postFileUpload(`${config.API_URL}/locations/import`, payload);

export const uploadFunctions = (payload: object) =>
  postFileUpload(`${config.API_URL}/locations/function/import`, payload);

//export

export const exportLocation = (payload: object) =>
  post(`${config.API_URL}/reports/export-locations`, payload);


export const clientUnAttachedLocation = (queryRequest: string) =>
  get(`${config.API_URL}/locations/location/unattach?${queryRequest}`);

